// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './ProductActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const ProductActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="ProductActionButtons">
    <Link to={`/write?edit_id=${id}&type=product`} className="modify-btn">
      수정
    </Link>
    <button className="delete-btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default ProductActionButtons;



// WEBPACK FOOTER //
// ./src/components/product/ProductActionButtons/ProductActionButtons.js